import { type FC } from 'react';
import { faRecycle } from '@fortawesome/pro-light-svg-icons/faRecycle';
import { formatCurrencyEur } from '../../Helper/formatter';
import InfoPill from '../InfoPill/InfoPill';

export interface DepositInfoPillProps {
  depositPrice?: number | null;
  depositUnitsCount?: number | null;
  compact?: boolean;
}

const DepositInfoPill: FC<DepositInfoPillProps> = ({
  depositPrice,
  depositUnitsCount,
  compact = false,
}) => {
  if (
    !depositPrice ||
    depositPrice <= 0 ||
    !depositUnitsCount ||
    depositUnitsCount <= 0
  ) {
    return null;
  }

  return (
    <InfoPill
      icon={faRecycle}
      value={depositUnitsCount}
      tooltip={`${depositUnitsCount} x ${formatCurrencyEur(
        depositPrice
      )} Deposit`}
      compact={compact}
    />
  );
};

export default DepositInfoPill;